const ITEMS = [
  "Acquisition Sourcing",
  "Private Lending",
  "Renovation Strategy",
  "BRRRR Turnkey",
  "Mortgage Financing",
  "Generational Wealth",
];

export const Marquee = () => {
  const row = [...ITEMS, ...ITEMS];
  return (
    <div className="relative border-y border-gold/15 py-7 overflow-hidden" data-testid="marquee">
      <div className="marquee-track">
        {[0, 1].map((k) => (
          <div key={k} className="flex shrink-0 items-center">
            {row.map((t, i) => (
              <span key={`${k}-${i}`} className="flex items-center">
                <span className="font-serif text-2xl sm:text-3xl font-light tracking-[0.12em] uppercase text-ivory/70 px-8">
                  {t}
                </span>
                <span className="h-1.5 w-1.5 rotate-45 bg-gold/70" />
              </span>
            ))}
          </div>
        ))}
      </div>
    </div>
  );
};
